import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box, Card, makeStyles, Container, CardHeader, Button, CardContent,
    Divider, MenuItem, Grid, InputLabel, TextField, Tooltip, IconButton
} from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import MaterialTable from "material-table";
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from "yup";
import moment from 'moment'
import { useAlert } from "react-alert";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { AlertDialogWithoutButton } from 'src/views/Common/AlertDialogWithoutButton';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import CloseIcon from '@material-ui/icons/Close';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    deleteIcon: {
        color: red[500],
        '&:hover': {
            color: red[700],
        }
    }
}));

const screenCode = 'DIRECTPURCHASEORDER';

export default function DirectPurchaseOrderListing(props) {
    const componentRef = useRef([]);
    const classes = useStyles();
    const navigate = useNavigate();
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [isShowTable, setIsShowTable] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [IDDataForDefaultLoad, setIsIDDataForDefaultLoad] = useState(null);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [budgetCodes, setBudgetCodes] = useState([]);
    const [isInitialLoadScreen, setIsInitialLoadScreen] = useState(false);
    const [dialogbox, setDialogbox] = useState(false);
    const [directPurchaseOrderID, setDirectPurchaseOrderID] = useState(0);
    const alert = useAlert()
    const [requisitionSearchDetails, setRequisitionSearchDetails] = useState({
        groupID: '0',
        factoryID: '0',
        dpoTypeID: '0',
        budgetCodeID: '0',
        statusID: '0',
    });

    const handleClick = () => {
        encrypted = btoa('0');
        encryptedStatusID = btoa('1');
        navigate('/app/directPurchaseOrder/addEdit/' + encrypted + '/' + encryptedStatusID);
    }

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
        isApproveButtonEnabled: false
    });

    useEffect(() => {
        trackPromise(getGroupsForDropdown());
    }, []);

    useEffect(() => {
        trackPromise(getFactoriesForDropdown(), getBudgetCodeDetails());
    }, [requisitionSearchDetails.groupID]);

    useEffect(() => {
        const IDdata = JSON.parse(
            sessionStorage.getItem('directPurchaseOrder-listing-page-search-parameters-id')
        );
        getPermissions(IDdata);
    }, []);

    useEffect(() => {
        if (IDDataForDefaultLoad != null || IDDataForDefaultLoad != undefined) {
            getDirectPurchaseOrderDetails();
        }
    }, [IDDataForDefaultLoad]);

    useEffect(() => {
        if (isInitialLoadScreen) {
            setRequisitionSearchDetails({
                ...requisitionSearchDetails,
                factoryID: '0',
                warehouseID: '0',
                budgetCodeID: '0',
                statusID: '0',
            })
            setToDate(new Date());
            setFromDate(new Date());
        }
    }, [requisitionSearchDetails.groupID])

    useEffect(() => {
        if (isInitialLoadScreen) {
            setRequisitionSearchDetails({
                ...requisitionSearchDetails,
                warehouseID: '0',
                budgetCodeID: '0',
                statusID: '0',
            })
            setToDate(new Date());
            setFromDate(new Date());
        }
    }, [requisitionSearchDetails.factoryID])

    useEffect(() => {
        if (isInitialLoadScreen) {
            setRequisitionSearchDetails({
                ...requisitionSearchDetails,
                budgetCodeID: '0',
                statusID: '0',
            })
            setToDate(new Date());
            setFromDate(new Date());
        }
    }, [requisitionSearchDetails.warehouseID])

    useEffect(() => {
        if (isInitialLoadScreen) {
            setRequisitionSearchDetails({
                ...requisitionSearchDetails,
                statusID: '0',
            })
            setToDate(new Date());
            setFromDate(new Date());
        }
    }, [requisitionSearchDetails.budgetCodeID])

    useEffect(() => {
        if (isInitialLoadScreen) {
            setToDate(new Date());
            setFromDate(new Date());
            setIsShowTable(false);
        }
    }, [requisitionSearchDetails.statusID])

    useEffect(() => {
        if (isInitialLoadScreen) {
            setToDate(new Date());
            setIsShowTable(false);
        }
    }, [fromDate])

    useEffect(() => {
        if (isInitialLoadScreen) {
            setIsShowTable(false);
        }
    }, [toDate])

    useEffect(() => {
        sessionStorage.removeItem('directPurchaseOrder-listing-page-search-parameters-id');
    }, []);


    async function getPermissions(IDdata) {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDIRECTPURCHASEORDER');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
        var isApproveButtonEnabled = permissions.find(p => p.permissionCode == 'APPROVEDIRECTPURCHASEORDER');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
            isApproveButtonEnabled: isApproveButtonEnabled !== undefined,
        });

        const initialValues = IDdata == null;
        if (initialValues) {
            setRequisitionSearchDetails({
                ...requisitionSearchDetails,
                groupID: parseInt(tokenService.getGroupIDFromToken()),
                factoryID: parseInt(tokenService.getFactoryIDFromToken())
            })
            setIsInitialLoadScreen(true);
        }
        else {
            setRequisitionSearchDetails({
                ...requisitionSearchDetails,
                groupID: parseInt(IDdata?.groupID),
                factoryID: parseInt(IDdata?.factoryID),
                warehouseID: parseInt(IDdata?.warehouseID),
                budgetCodeID: parseInt(IDdata?.budgetCodeID),
                statusID: parseInt(IDdata?.statusID),
            })

            setFromDate(new Date(IDdata.fromDate).toString());
            setToDate(new Date(IDdata?.toDate));
        }
        setIsIDDataForDefaultLoad(IDdata)
    }


    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getFactoriesForDropdown() {
        const factories = await services.getAllFactoriesByGroupID(requisitionSearchDetails.groupID);
        setFactories(factories);
    }

    async function getBudgetCodeDetails() {
        var response = await services.getBudgetCodeDetails();
        setBudgetCodes(response);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setRequisitionSearchDetails({
            ...requisitionSearchDetails,
            [e.target.name]: value
        });
        setIsShowTable(false);
    }
    let encrypted = "";
    let encryptedStatusID = "";
    const handleClickEdit = (directPurchaseOrderID, statusID) => {
        encrypted = btoa(directPurchaseOrderID.toString());
        encryptedStatusID = btoa(statusID.toString());
        let model = {
            groupID: parseInt(requisitionSearchDetails.groupID),
            factoryID: parseInt(requisitionSearchDetails.factoryID),
            dpoTypeID: parseInt(requisitionSearchDetails.dpoTypeID),
            budgetCodeID: parseInt(requisitionSearchDetails.budgetCodeID),
            fromDate: fromDate,
            toDate: toDate,
        }
        sessionStorage.setItem('directPurchaseOrder-listing-page-search-parameters-id', JSON.stringify(model));
        navigate('/app/directPurchaseOrder/addEdit/' + encrypted + '/' + encryptedStatusID);
    }

    async function getDirectPurchaseOrderDetails() {
        let model = {
            groupID: parseInt(requisitionSearchDetails.groupID),
            factoryID: parseInt(requisitionSearchDetails.factoryID),
            dpoTypeID: parseInt(requisitionSearchDetails.dpoTypeID),
            budgetCodeID: parseInt(requisitionSearchDetails.budgetCodeID),
            fromDate: moment(fromDate.toString()).format('').split('T')[0],
            toDate: moment(toDate.toString()).format('').split('T')[0]
        }
        const response = await services.getDirectPurchaseOrderDetails(model);
        if (response.statusCode == 'Success') {
            response.data.forEach((x, i) => {
                x.index = i
            });

            setTableData(response.data);
            setIsShowTable(true);
        }
        else {
            setTableData([]);
            alert.error("No Data")
        }
        setIsIDDataForDefaultLoad(null);
        setIsInitialLoadScreen(true);
    }

    async function confirmData() {
        var res = await services.DeleteDirectPurchaseOrder(directPurchaseOrderID, tokenService.getUserIDFromToken());
        if (res.statusCode == "Success") {
            alert.success("Direct Purchase Order Deleted Successfully");
            trackPromise(getDirectPurchaseOrderDetails())
        }
        else {
            alert.error("Error occured in Delete Direct Purchase Order");
        }
        setDialogbox(false);
    }

    function cancelData() {
        setDialogbox(false);
    }

    function handleDelete(directPurchaseOrderID) {
        setDialogbox(true)
        setDirectPurchaseOrderID(directPurchaseOrderID)
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader
                        onClick={handleClick}
                        isEdit={true}
                        toolTiptitle={"Add Direct Purchase Order"}
                    />
                </Grid>
            </Grid>
        )
    }

    return (
        <Fragment>
            <LoadingComponent />
            <Page
                className={classes.root}
                title="Direct Purchase Order"
            >
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: requisitionSearchDetails.groupID,
                            factoryID: requisitionSearchDetails.factoryID,
                            dpoTypeID: requisitionSearchDetails.dpoTypeID,
                            budgetCodeID: requisitionSearchDetails.budgetCodeID,
                        }}
                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory required').min("1", 'Factory is required'),
                                budgetCodeID: Yup.number().required('Account Code Name required').min("1", 'Account Code Name is required'),
                            })
                        }
                        onSubmit={() => trackPromise(getDirectPurchaseOrderDetails())}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleSubmit,
                            touched,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle("Direct Purchase Order")}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent style={{ marginBottom: "2rem" }}>
                                                <Grid container spacing={3}>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            helperText={touched.groupID && errors.groupID}
                                                            fullWidth
                                                            name="groupID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={requisitionSearchDetails.groupID}
                                                            variant="outlined"
                                                            size="small"
                                                            InputProps={{
                                                                readOnly: !permissionList.isGroupFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            fullWidth
                                                            name="factoryID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={requisitionSearchDetails.factoryID}
                                                            variant="outlined"
                                                            size="small"
                                                            InputProps={{
                                                                readOnly: !permissionList.isFactoryFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="dpoTypeID">
                                                            DPO Type
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.dpoTypeID && errors.dpoTypeID)}
                                                            helperText={touched.dpoTypeID && errors.dpoTypeID}
                                                            fullWidth
                                                            name="dpoTypeID"
                                                            size='small'
                                                            onChange={(e) => handleChange(e)}
                                                            value={requisitionSearchDetails.dpoTypeID}
                                                            variant="outlined"
                                                        >
                                                            <MenuItem value="0">--Select DPO Type--</MenuItem>
                                                            <MenuItem value="1">Order</MenuItem>
                                                            {/* <MenuItem value="2">Request</MenuItem> */}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="budgetCodeID">
                                                            Account Code Name *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.budgetCodeID && errors.budgetCodeID)}
                                                            fullWidth
                                                            helperText={touched.budgetCodeID && errors.budgetCodeID}
                                                            size='small'
                                                            name="budgetCodeID"
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={requisitionSearchDetails.budgetCodeID}
                                                            variant="outlined"
                                                        >
                                                            {generateDropDownMenu(budgetCodes)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="fromDate" style={{ marginBottom: '-8px' }}>
                                                            From Date *
                                                        </InputLabel>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                autoOk
                                                                fullWidth
                                                                inputVariant="outlined"
                                                                format="dd/MM/yyyy"
                                                                margin="dense"
                                                                id="fromDate"
                                                                value={fromDate}
                                                                onChange={(e) => {
                                                                    setFromDate(e);
                                                                }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="toDate" style={{ marginBottom: '-8px' }}>
                                                            To Date *
                                                        </InputLabel>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                autoOk
                                                                fullWidth
                                                                inputVariant="outlined"
                                                                format="dd/MM/yyyy"
                                                                margin="dense"
                                                                id="toDate"
                                                                value={toDate}
                                                                onChange={(e) => {
                                                                    setToDate(e);
                                                                }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                </Grid>
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        variant="contained"
                                                    >
                                                        Search
                                                    </Button>
                                                </Box>
                                            </CardContent>
                                            {isShowTable ?
                                                <Box minWidth={1050}>
                                                    <MaterialTable
                                                        title="Multiple Actions Preview"
                                                        columns={[
                                                            { title: 'DPO No', field: 'dpoNumber' },
                                                            { title: 'Factory', field: 'factoryName' },
                                                            { title: 'DPO Type', field: 'dpoTypeID', render: date => date.dpoTypeID == 1 ? 'Order' : 'Request' },
                                                            { title: 'Supplier', field: 'supplierName' },
                                                            { title: 'Account Code', field: 'budgetCodeName' },
                                                            { title: 'Purchase Date', field: 'purchaseDate', render: date => moment(date.purchaseDate).format().split('T')[0] },
                                                            {
                                                                title: 'Status', field: 'status', lookup: {
                                                                    1: 'Pending',
                                                                    2: 'Approved',
                                                                    3: 'Rejected',
                                                                    4: 'GRN Completed'
                                                                }
                                                            },
                                                            {
                                                                title: 'PDF', field: 'button',
                                                                render: (rowData) => {
                                                                    componentRef.current[rowData.index] = componentRef.current[rowData.index]
                                                                    if (rowData.status === 2 || rowData.status === 4) {
                                                                        return (
                                                                            <>
                                                                                <ReactToPrint
                                                                              documentTitle={"Direct_Purchase_Order_" + factories[requisitionSearchDetails.factoryID] + "_" + groups[requisitionSearchDetails.groupID] + "_Direct_Purchase_Order_"+rowData.dpoNumber}                                                                                    
                                                                              trigger={() => (
                                                                                        <Tooltip title="PDF">
                                                                                            <IconButton
                                                                                                aria-label="PDF"
                                                                                            >
                                                                                                <PictureAsPdfIcon style={{ color: 'red' }} />
                                                                                            </IconButton>
                                                                                        </Tooltip>
                                                                                    )}
                                                                                    content={() => componentRef.current[rowData.index]}
                                                                                />
                                                                                <div hidden={true}>
                                                                                    <CreatePDF
                                                                                        ref={(el) => (componentRef.current[rowData.index] = el)}
                                                                                        dpoData={rowData.details}
                                                                                    />
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    }
                                                                }
                                                            }

                                                        ]}
                                                        data={tableData}
                                                        options={{
                                                            exportButton: false,
                                                            showTitle: false,
                                                            headerStyle: { textAlign: "left", height: '1%' },
                                                            cellStyle: { textAlign: "left" },
                                                            columnResizable: false,
                                                            actionsColumnIndex: -1,
                                                            pageSize: 10
                                                        }}
                                                        actions={[
                                                            // rowData => ({
                                                            //     hidden: (rowData.status == 2 || rowData.status == 3),
                                                            //     icon: 'edit',
                                                            //     tooltip: 'Edit',
                                                            //     onClick: (event, rowData) => handleClickEdit(rowData.directPurchaseOrderID, 2),
                                                            // }),
                                                            rowData => ({
                                                                hidden: (rowData.status == 1),
                                                                icon: 'visibility',
                                                                tooltip: 'View',
                                                                onClick: (event, rowData) => handleClickEdit(rowData.directPurchaseOrderID, 3)
                                                            }),
                                                            rowData => ({
                                                                hidden: (rowData.status === 1 || rowData.status === 4),
                                                                icon: () => <CloseIcon style={{ color: 'red' }} />,
                                                                tooltip: 'Delete',
                                                                onClick: (event, rowData) =>
                                                                    handleDelete(rowData.directPurchaseOrderID)
                                                            })
                                                            // rowData => ({
                                                            //     hidden: (permissionList.isApproveButtonEnabled == false || rowData.status == 2 || rowData.status == 3),
                                                            //     icon: 'check',
                                                            //     tooltip: 'Approve',
                                                            //     onClick: (event, rowData) => handleClickEdit(rowData.directPurchaseOrderID, 4)
                                                            // })
                                                        ]}
                                                    />
                                                </Box>
                                                : null}
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>

                            </form>
                        )}
                    </Formik>
                </Container>
                {dialogbox ? <AlertDialogWithoutButton confirmData={confirmData} cancelData={cancelData}
                    IconTitle={"Delete"}
                    headerMessage={"Are you sure you want to delete ?"}
                /> : null}
            </Page >
        </Fragment>

    )
}
